import { SyntheticEvent } from 'react';

export const scrollToElement = (text: string, id: string, optionalElementName: string = 'terms-of-use-app'): void => {
  if (text.includes(id)) {
    const customElement = document.getElementsByTagName(optionalElementName);
    if (customElement.length) {
      const element = customElement[0]?.shadowRoot?.getElementById(id);
      element?.scrollIntoView();
    }
  }
};

export const scrollToElementWithoutEvent = (
  event: SyntheticEvent | Event,
  text: string,
  target: string,
  optionalScrollToElement = scrollToElement,
): void => {
  event.preventDefault();
  optionalScrollToElement(text, target);
};

export const onScroll = (
  text: string,
  target: string,
  optionalScrollToElement = scrollToElement,
): ((event: SyntheticEvent | Event) => void) => (
  (event: SyntheticEvent | Event) => scrollToElementWithoutEvent(event, text, target, optionalScrollToElement)
);
